import { Component, OnInit, OnDestroy } from '@angular/core';
import { interval, Subscription } from 'rxjs';

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss'],
    standalone: false
})
export class HeaderComponent implements OnInit, OnDestroy {
  
  currentDate: string = '';
  currentTime: string = '';
  private timeSubscription?: Subscription;

  ngOnInit(): void {
    this.updateDateTime();
    
    // Mise à jour toutes les secondes
    this.timeSubscription = interval(1000).subscribe(() => {
      this.updateDateTime();
    });
  }

  ngOnDestroy(): void {
    if (this.timeSubscription) {
      this.timeSubscription.unsubscribe();
    }
  }

  private updateDateTime(): void {
    const now = new Date();
    
    // Format de la date: "9 FEVRIER"
    const day = now.getDate();
    const months = [
      'JANVIER', 'FEVRIER', 'MARS', 'AVRIL', 'MAI', 'JUIN',
      'JUILLET', 'AOÛT', 'SEPTEMBRE', 'OCTOBRE', 'NOVEMBRE', 'DÉCEMBRE'
    ];
    const month = months[now.getMonth()];
    this.currentDate = `${day} ${month}`;
    
    // Format de l'heure: "14:37:36"
    const hours = String(now.getHours()).padStart(2, '0');
    const minutes = String(now.getMinutes()).padStart(2, '0');
    const seconds = String(now.getSeconds()).padStart(2, '0');
    this.currentTime = `${hours}:${minutes}:${seconds}`;
  }
}